import get from 'lodash/get'
import { connect } from 'react-redux'

import { HotLeisureTips } from 'common/widgets'


export default connect((_, props) => ({
  data: get(props, 'school.static_content.leisure_tips'),
  schoolName: get(props, 'school.name'),
}))(HotLeisureTips)
